import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { registerUpdateDialog, handleUpdateConfirm } from '../utils/versionChecker';

const VersionUpdateDialog = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Register this dialog as the update notification handler
    registerUpdateDialog(() => {
      setVisible(true);
    });
  }, []);

  const onReload = () => {
    handleUpdateConfirm();
  };

  const onLater = () => {
    setVisible(false);
  };

  const footer = (
    <div>
      <Button 
        label="Później" 
        icon="pi pi-times" 
        onClick={onLater} 
        className="p-button-text" 
      />
      <Button 
        label="Przeładuj" 
        icon="pi pi-refresh" 
        onClick={onReload} 
        autoFocus 
      />
    </div>
  );

  return (
    <Dialog
      header="Nowa wersja"
      visible={visible}
      style={{ width: '450px' }}
      footer={footer}
      onHide={onLater}
      draggable={false}
      resizable={false}
    >
      <div className="confirmation-content">
        <i className="pi pi-exclamation-triangle" style={{ fontSize: '2rem', marginRight: '1rem' }} />
        <span>
          Dostępna jest nowa wersja aplikacji. Czy chcesz przeładować stronę?
        </span>
      </div>
    </Dialog>
  );
};

export default VersionUpdateDialog;
